/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {KTIcon} from '../../../_metronic/helpers'

type Props = {
  setpopupfromcard?: any
  adminId: number
  profilePicture: any
  fullName: any
  mobileNumber: any
  countryCode: any
  email: any
}

const Card2: FC<Props> = ({
  adminId,
  profilePicture,
  fullName,
  mobileNumber,
  email,
  countryCode,
  setpopupfromcard,
}) => {
  return (
    <div className='col-md-6 col-xxl-4 col-lg-6 mb-5'>
      <div className='card'>
        <div className='card-body d-flex flex-center flex-column p-9'>
          <div className='mb-5'>
            <div className='symbol symbol-75px symbol-circle'>
              {!profilePicture ? (
                <span className={`symbol-label bg-light-danger fs-5 fw-bolder`}>
                  {fullName.charAt(0)}
                </span>
              ) : (
                <img alt='Pic' src={profilePicture} />
              )}
         
            </div>
          </div>

          <Link to='#' className='fs-4 text-gray-800 text-hover-primary fw-bolder mb-0'>
            {/* {name} */}
          </Link>

          <div className='fw-bold text-gray-400 mb-6'>{fullName}</div>

          <div className='mb-5 row col-lg-12'>
            <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 mx-3 mb-3 col'>
              <div className='fs-6 fw-bolder text-gray-700'>Mobile Number</div>
              <div className='fw-bold text-gray-400 fs-7'>
                {countryCode != null && countryCode != '' ? '+' + countryCode + ' ' : ''}
                {mobileNumber}
              </div>
            </div>
            <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 mx-3 mb-3 col'>
              <div className='fs-6 fw-bolder text-gray-700'>Email</div>
              <div className='fw-bold text-gray-400 fs-7'>{email}</div>
            </div>
          </div>
        </div>
        <div className='d-flex flex-center flex-wrap mb-5'>
          <Link
            to='#'
            className='btn btn-sm btn-secondary'
            onClick={() => setpopupfromcard(adminId, 'delete')}
          >
            <KTIcon iconName='delete' className='fs-3' />
            Delete
          </Link>
          <Link
            to='#'
            className='btn btn-sm btn-primary mx-3'
            onClick={() => {
              setpopupfromcard(adminId, 'edit', 'edit')
            }}
          >
            <KTIcon iconName='pen' className='fs-3' />
            Edit
          </Link>
        </div>
      </div>
    </div>
  )
}

export {Card2}
